/* ============
 * Package Transformer
 * ============
 *
 * The transformer for the Package.
 */

import Transformer from './transformer';

export default class packageTransformer extends Transformer {

  static fetch(packageOrderProduct) {
    return {
      id: packageOrderProduct.id,
      hashid: packageOrderProduct.hashid,
      orderProductId: packageOrderProduct.order_product_id,
      quantity: packageOrderProduct.quantity,
      quantityUnit: packageOrderProduct.quantity_unit,
      quantityText: packageOrderProduct.quantity_text,
      grossWeight: packageOrderProduct.gross_weight,
      netWeight: packageOrderProduct.net_weight,
      stackWeight: packageOrderProduct.stack_weight,
      bestBefore: packageOrderProduct.best_before,
      maxTopLoad: packageOrderProduct.max_top_load,
      batchLotNumber: packageOrderProduct.batch_lot_number,
      temperatureRequirement: packageOrderProduct.temperature_requirement,
      packageId: packageOrderProduct.package_id,
      gtin: packageOrderProduct.gtin,
      productName: packageOrderProduct.product_name,
      quantityExceedError: packageOrderProduct.quantity_exceed_error,
      weights: packageOrderProduct.weights,
      temperatureText: packageOrderProduct.temperature_text,
    };
  }

  static send(packageOrderProduct) {
    return {
      id: packageOrderProduct.id,
      order_product_id: packageOrderProduct.orderProductId,
      quantity: packageOrderProduct.quantity,
      quantity_unit: packageOrderProduct.quantityUnit,
      gross_weight: packageOrderProduct.grossWeight,
      net_weight: packageOrderProduct.netWeight,
      stack_weight: packageOrderProduct.stackWeight,
      best_before: packageOrderProduct.bestBefore,
      max_top_load: packageOrderProduct.maxTopLoad,
      batch_lot_number: packageOrderProduct.batchLotNumber,
      temperature_requirement: packageOrderProduct.temperatureRequirement,
      package_id: packageOrderProduct.packageId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/packageOrderProduct.js